
import WidgetBase from '../widget.base';
import { each, getIndex, getMobileOperatingSystem } from '../../lib/util';
import { duration } from '../../lib/const';
import featSniffer from 'App/lib/featureDetection';
import DomComponent from '../../lib/domComponent';
import bodyService from '../../services/body';

export default class StoreDetailsComponent extends WidgetBase {
    static selector = '[data-js-detail-page]';
    activeClass = 'active';
    activeIndex = 0;

    constructor(el){
        super(el);
        this.gallery = this.el.querySelector('[data-js-gallery]');
        this.galleryArrows = this.el.querySelectorAll('[data-gallery-arrow]');
        this.galleryChildren = this.el.querySelectorAll('[data-js-gallery-image]');
        this.thumbnails = this.el.querySelectorAll('[data-js-gallery-thumbnail]');
        this.galleryTrack = this.el.querySelector('[data-js-gallery-track]');
        this.galleryVideos = this.el.querySelectorAll('[data-vimeo]');
        this.readMore = this.el.querySelector('[data-js-read-more]');
        this.readMoreContainer = this.el.querySelector('[data-js-read-more-container]');
        this.mobileDealsButton = this.el.querySelector('[data-js-deals-button]');
        this.mobileDealsButtonClose = this.el.querySelector('[data-js-deals-button-close]');
        this.mobileDealsDropdown = this.el.querySelector('[data-js-deals-dropdown]');
        this.downloadAppButton = this.el.querySelector('[data-download-app]');
        // this.mobileEventPromotions = this.el.querySelector('[data-js-event-promotions]');
        this.activeTrackIndexes = [];
        this.translateAmount = 0;

        if (this.galleryChildren.length === 1) {
            this.gallery.classList.add('one-item');
            this.galleryTrack.style.display = 'none';
        }

        if (this.readMore) {
            this.readMore.addEventListener('click',this.readMoreClick.bind(this));
        }

        if (this.mobileDealsButton) {
            this.mobileDealsButton.addEventListener('click', this.showDeals.bind(this));
        }

        if (this.mobileDealsButtonClose) {
            this.mobileDealsButtonClose.addEventListener('click', this.hideDeals.bind(this));
        }

        each(this.thumbnails, (thumbnail, index) => {
            if (this.activeTrackIndexes.length < 4) {
                this.activeTrackIndexes.push(index);
            }
            thumbnail.dataset.index = index;
            thumbnail.addEventListener('click', this.thumbnailClick.bind(this));
        });

        const modalEl = document.querySelector('[data-js-modal]');
        const modalComponent = DomComponent.getComponentByRef(modalEl.dataset.ref);
        modalComponent.addIframeVimeoTriggers(this.galleryVideos);

        each(this.galleryArrows, (arrow) => {
            arrow.addEventListener('click', (e) => {
                // clearInterval(this.interval);
                const direction = arrow.dataset.galleryArrow;
                if(direction === "next"){
                    this.next();
                } else {
                    this.prev();
                }
            });
        });

        if(featSniffer.touch() && this.galleryChildren.length > 0){
            this.addTouchEvents(this.gallery);
        }
        
        if (this.downloadAppButton) {
            this.downloadAppButton.addEventListener('click', this.goToAppDownload.bind(this));
        }

        setTimeout(() => {
            this.loaded();
        })
        setTimeout(() => {
            this.chatButton = document.querySelector('#divSatisfiChat');
        }, 300);
    }

    // goToDeals() {
    //     const headerHeight = document.querySelector('[data-js-header]').offsetHeight;
    //     const top = this.mobileEventPromotions.getBoundingClientRect().top;
    //     scrollToPosition(top - headerHeight, 300);
    // }

    showDeals() {
        bodyService.lock();
        this.mobileDealsDropdown.classList.add('open');
        if (this.chatButton) {
            this.chatButton.style.display = 'none';
        }
    }

    hideDeals() {
        bodyService.unlock();
        this.mobileDealsDropdown.classList.remove('open');
        if (this.chatButton) {
            this.chatButton.style.display = '';
        }
    }

    goToAppDownload() {
        // const offer = offerId.dataset.offerId;
        const phone = getMobileOperatingSystem();
        if (phone === 'iOS') {
            window.location.href = this.mobileDealsDropdown.dataset.appleAppStoreAppUrl;
        }
        if (phone === 'Android') {
            window.location.href = this.mobileDealsDropdown.dataset.googlePlayAppUrl;
        }
    }

    readMoreClick() {
        this.readMoreContainer.classList.add('read-more');
    }

    prev() {
        let index = this.activeIndex;
        index = (index-1 < 0) ? this.galleryChildren.length-1 : index-1;
        this.navigateToImage(index);
        this.updateThubmnailTrack(index);
        this.activeIndex = index;
    }

    next() {
        let index = this.activeIndex;
        index = (index+1 === this.galleryChildren.length) ? 0 : index+1;
        this.navigateToImage(index);
        this.updateThubmnailTrack(index);
        this.activeIndex = index;
    }

    thumbnailClick(e) {
        if (e.currentTarget.classList.contains('active') === true) {
            return;
        }
        const target = e.currentTarget;
        const index = Number(target.dataset.index);
        this.navigateToImage(index);
        this.updateThubmnailTrack(index);
        this.activeIndex = index;
    }

    // galleryInterval(){
    //     let index = this.activeIndex;
    //     index = (index+1 === this.pager.children.length) ? 0 : index+1;
    //     this.navigateToImage(index);
    // }

    updateThubmnailTrack(newIndex) {
        const currentTrigger = this.thumbnails[this.activeIndex];
        const incoming = this.thumbnails[newIndex];

        currentTrigger.classList.remove('active');
        incoming.classList.add('active');

        if (this.galleryChildren.length < 5) {
            return;
        }

        if (this.activeTrackIndexes.indexOf(newIndex) !== -1) {
            return;
        }

        if(newIndex === this.galleryChildren.length - 1) {
            //subtract the new index by number of shown thumbanils. This case it's 3 (base 0)
            const difference = Math.abs(newIndex - 3);
            this.translateAmount = -difference * 25;
            this.activeTrackIndexes = [this.galleryChildren.length - 4,
                                        this.galleryChildren.length - 3,
                                        this.galleryChildren.length - 2,
                                        this.galleryChildren.length - 1];
        }
        else if(newIndex === 0) {
            this.activeTrackIndexes = [0, 1, 2, 3];
            this.translateAmount = 0;
        }
        else if (newIndex > this.activeIndex) {
            this.translateAmount -= 25;
            this.activeTrackIndexes = this.activeTrackIndexes.map((index) => index + 1);
        }
        else {
            this.translateAmount += 25;
            this.activeTrackIndexes = this.activeTrackIndexes.map((index) => index - 1);
        }

        // this.translateAmount -= 25;
        this.galleryTrack.style.transform = `translateX(${this.translateAmount}%)`;
    }

    navigateToImage(index){
        const pagerTrigger = this.galleryChildren[index];
        const incoming = this.galleryChildren[index];
        const current = this.galleryChildren[this.activeIndex];

        // pagerTrigger.classList.add(this.activeClass);
        // this.galleryChildren[this.activeIndex].classList.remove(this.activeClass);

        if (this.activeIndex === this.galleryChildren.length - 1 && index === 0){
            this.setTransform('right', incoming);
        }
        else if(this.activeIndex === 0 && index === this.galleryChildren.length - 1){
            this.setTransform('left', incoming);
        }
        else if(index < this.activeIndex) {
            this.setTransform('left', incoming);
        }else{
            this.setTransform('right', incoming);
        }

        setTimeout(() => {
            incoming.classList.add('animating');
            this.setTransform('center', incoming);

            setTimeout(() => {
                incoming.classList.remove('animating');
                incoming.classList.add(this.activeClass);
                current.classList.remove(this.activeClass);
            }, duration);
        });


    }

    setTransform(state, el) {
        let transformX;
        if(state === 'center') {
            transformX = '0';
        }else{
            transformX = state === 'right' ? '100%' : '-100%';
        }
        el.style.transform = `translate3d(${transformX}, 0, 0)`;
    }


    addTouchEvents(element, collectionIdx){
        let isTouchStart = false;

        let isSwipeLeft = false;

        let incomingImage;

        // initial mouse X for `mousedown`
        let touchX;
        let touchY;

        // element transform style before/after
        let transformX;

        // element X before and after move
        let elementX = 0;

        element.addEventListener('touchstart', onTouchStart.bind(this));

        /**
         * Listens to `mousedown` event.
         *
         * @param {Object} event - The event.
         */
        function onTouchStart(event) {
            // if(this.interval != null){
            //     clearInterval(this.interval);
            // }


            element.classList.add('dragging');
            touchX = event.touches[0].clientX;
            touchY = event.touches[0].clientY;
            isTouchStart = true;
            const incoming = this.galleryChildren[1];

            if(this.galleryChildren[1].style.transform == ""){
                this.galleryChildren[1].style.transform = `translate3d(${screen.width}, -50%, 0)`;
            }
            // transformX = parseTransformX(this.galleryChildren[1].style.transform);
        }

        // mouse button released
        element.addEventListener('touchend', onTouchEnd.bind(this));

        /**
         * Listens to `mouseup` event.
         *
         * @param {Object} event - The event.
         */
        function onTouchEnd(event) {
            if (event.target.hasAttribute('data-gallery-arrow')) return;
            // const incoming = this.galleryChildren[1];
            const current = this.galleryChildren[this.activeIndex];
            incomingImage.classList.remove('dragging');
            incomingImage.classList.add('animating');
            var newSlide = false;

            const newIndex = getIndex(incomingImage);
            // const pagerTrigger = this.galleryChildren[newIndex];
            // pagerTrigger.classList.add(this.activeClass);
            this.updateThubmnailTrack(newIndex);
            var elementX = parseTransformX(incomingImage.style.transform);
            const originalIndex = this.activeIndex;


            this.setTransform('center', incomingImage);
            newSlide = true;


            this.activeIndex = newIndex;



            setTimeout(function(){
                this.galleryChildren[originalIndex].classList.remove(this.activeClass);
                incomingImage.classList.remove('animating');
                if(newSlide === true){
                    incomingImage.classList.add(this.activeClass);
                    current.classList.remove(this.activeClass);
                }
                // this.galleryChildren[1].remove('animating');
                incomingImage = null;
            }.bind(this), duration);
        }

        function parseTransformX(transform) {
            return parseInt(transform.split('(')[1].split(',')[0])
        }

        element.addEventListener('touchmove', onTouchMove.bind(this));

        function onTouchMove(event) {
            if (!isTouchStart) return;

            var deltaX = event.touches[0].clientX - touchX;
            var deltaY = event.touches[0].clientY - touchY;

            if(deltaX > 0){
                isSwipeLeft = false;
            } else{
                isSwipeLeft = true;
            }

            if(incomingImage == null){
                if(isSwipeLeft){

                    let newIndex = this.activeIndex + 1;
                    if(newIndex === this.galleryChildren.length){
                        newIndex = 0;
                    }
                    incomingImage = this.galleryChildren[newIndex];
                } else{

                    let newIndex = this.activeIndex - 1;
                    if(newIndex < 0){
                        newIndex = this.galleryChildren.length -1;
                    }
                    incomingImage = this.galleryChildren[newIndex];
                }
            }

            const absDeltaX = Math.abs(deltaX);
            const absDeltaY = Math.abs(deltaY);

            if(absDeltaY > absDeltaX) {
                return false;
            }

            deltaX = screen.width - Math.abs(deltaX);
            deltaX = isSwipeLeft ? deltaX : -1 * deltaX;

            incomingImage.classList.add('dragging');
            incomingImage.style.transform = 'translate3d(' + ( deltaX) + 'px, 0, 0)';
            event.preventDefault();
        }
    }

}